import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'mrTranslate',
})
export class MrTranslatePipe implements PipeTransform {
  private translateService = inject(TranslateService);

  transform(value: string, ...args: any[]): string {
    if (value && value !== '' && typeof value === 'string') {
      let result = this.translateEncodedKey(value, args);
      if (!result && value[0] === value[0].toUpperCase())
        result = this.translateEncodedKey(value.toLowerCase(), args);
      if (!result && value[0] === value[0].toLowerCase())
        result = this.translateEncodedKey(value[0].toUpperCase() + value.slice(1), args);

      if (environment.debugTranslation && !(result && result !== ''))
        console.debug('Translation not found:', "'" + value + "'");

      result = result && result !== '' ? result : value;
      return result;
    }
    return value;
  }

  private translateEncodedKey(value: string, args: any[]): string {
    const encoded = encodeURIComponent(value);
    const formatted = this.translateService.instant(encoded, ...args);
    return formatted === encoded ? '' : formatted;
  }
}
